import styled from 'styled-components';
import IconArrowDownOutline from './IconArrowDownOutline';
var IconArrowLeftOutline = /*#__PURE__*/styled(IconArrowDownOutline).withConfig({
  displayName: "IconArrowLeftOutline",
  componentId: "c11n-8-111-1__sc-daxcpt-0"
})(["transform:rotate(90deg);"]);
export default IconArrowLeftOutline;